import { useFeatureFlags } from 'src/context';

export const useEnableNewSidebar = (): boolean => {
  const { EnableNewSidebar } = useFeatureFlags();
  return EnableNewSidebar;
};
